import React from 'react';

const RemoveBackgroundIcon = ({ size = 16, fill = 'black', ...props }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...props}
      style={{ fill }}
    >
      <path
        d="M5.75 3H7.41417L3 7.41417V5.75C3 4.23122 4.23122 3 5.75 3Z"
        fill={fill}
      ></path>
      <path
        d="M3 10.5861V13.4145L7.15512 9.25937C7.60563 7.49479 8.99479 6.10563 10.7594 5.65512L13.4145 3H10.5861L3 10.5861Z"
        fill={fill}
      ></path>
      <path
        d="M5.44499 14.1411L3 16.5861V18.25C3 18.5965 3.06409 18.9281 3.18106 19.2334L5 17.4145V16.184C5 15.496 5.14704 14.7892 5.44499 14.1411Z"
        fill={fill}
      ></path>
      <path
        d="M15.4925 6.92197C15.0035 6.44451 14.4169 6.0665 13.7655 5.82061L16.5861 3H18.25C18.5965 3 18.9281 3.06409 19.2334 3.18106L15.4925 6.92197Z"
        fill={fill}
      ></path>
      <path
        d="M16.8963 11.5178C16.9642 11.1892 17 10.8488 17 10.5C17 9.92577 16.9032 9.37415 16.725 8.86057L20.819 4.76663C20.9359 5.07198 21 5.40351 21 5.75V7.41402L16.8963 11.5178Z"
        fill={fill}
      ></path>
      <path
        d="M18.9469 15.4676C18.8412 14.7533 18.5773 14.0474 18.1507 13.4354L21 10.5861V13.4145L18.9469 15.4676Z"
        fill={fill}
      ></path>
      <path
        d="M19 20.8965V18.5861L21 16.5861V18.25C21 19.5088 20.1543 20.57 19 20.8965Z"
        fill={fill}
      ></path>
      <path
        d="M13.445 13.1297C14.3719 12.6193 15 11.633 15 10.5C15 8.84315 13.6569 7.5 12 7.5C10.3431 7.5 9 8.84315 9 10.5C9 11.6327 9.62777 12.6188 10.5544 13.1293C9.80163 13.2785 9.09672 13.5182 8.51632 13.7555C7.54567 14.1523 7 15.1354 7 16.184V21.0005H17V16.1861C17 15.1391 16.456 14.1573 15.4874 13.7596C14.9061 13.521 14.1996 13.2797 13.445 13.1297Z"
        fill={fill}
      ></path>
    </svg>
  );
};
export default RemoveBackgroundIcon;
